import styles from '../index.module.css'

export default function ConfirmModal({
  modalCloseCallback,
  successCallback,
  children,
}: {
  modalCloseCallback: () => void
  successCallback: () => void
  children: React.ReactNode
}) {
  return (
    <div
      className={`${styles.modal} ${styles['modal--open']} ${styles['modal-confirmation']}`}
    >
      <div className={styles['modal-header']}>Confirmation</div>
      <div className={styles['modal-content']}>
        {children}
        <div className={styles['modal-buttons']}>
          <div
            className={`${styles['button']} ${styles['yes-button']}`}
            onClick={successCallback}
          >
            Yes
          </div>
          <div
            className={`${styles['button']} ${styles['no-button']}`}
            onClick={modalCloseCallback}
          >
            No
          </div>
        </div>
      </div>
    </div>
  )
}
